<template>
    <div class="decree-widget-wrapper">
        <div class="decree-widget"
            :class="{
                [typeToClass(decree.type)]: true,
                ['selectable']: selectable,
                ['btn btn-3d btn-gray btn-outline']: selectable || isSpectator,
                [player.team.color]: true,
                ['disabled']: !selectable,
                ['last']: index === 2,
                ['claimed']: claimed,
                ['spectator']: isSpectator,
                ['btn']: drafting,
            }"
            @click="onCommand"
        >
            <div class="decree-name">{{decree.name}}</div>
            <div class="decree-markers">
                <div
                    class="decree-marker-wrapper white"
                    :class="{['claimed']: decree.whiteTeamId }"
                    v-if="!hideMarkers"
                >
                    <span class="decree-shadow"></span>
                    <decree-marker color="white" :theme="theme" :selected="decree.whiteTeamId" />
                </div>
                <div
                    class="decree-marker-wrapper black"
                    :class="{['claimed']: decree.blackTeamId }"
                    v-if="!hideMarkers"
                >
                    <span class="decree-shadow"></span>
                    <decree-marker color="black" :theme="theme" :selected="decree.blackTeamId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import find from 'lodash.find';

export default {
    props: ['decree', 'index', 'drafting', 'hideMarkers'],
    name: 'DecreeWidget',
    computed: {
        type() {
            return this.decree.type.toLowerCase();
        },
        selectable() {
            return find(this.selectedUnitActions, { type: this.type, unitId: this.selectedUnitId });
        },
        claimed() {
            return this.decree[`${this.player.team.color}TeamId`] === this.player.team.id;
        },
        selectedUnitId() {
            return this.$store.state.actionsState.selectedUnitId;
        },
        selectedUnitActions() {
            return this.$store.state.actionsState.selectedUnitActions;
        },
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        player() {
            return this.isGame ? this.$store.getters.player : this.$store.getters.replayPlayer;
        },
        isGame() {
            return this.$route.name === 'game';
        },
        isSpectator() {
            return this.isGame ? this.$store.getters.isSpectator : true;
        },
        theme() {
            return this.$store.state.gameState.theme;
        },
    },
    methods: {
        typeToClass(text) {
            return text.split(/[^A-Z]+/i).map(word => word.toLowerCase()).join('-');
        },
        async onCommand() {
            if (!this.selectable) {
                return;
            }

            await this.$store.dispatch('sendCommand',
                {
                    actionType: this.type,
                    gameId: this.gameId,
                    playerId: this.player.id,
                    $socket: this.$socket,
                    $notify: this.$notify,
                    decreeId: this.decree.id,
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .decree-widget-wrapper {
        display: flex;
        flex-shrink: 0;
        margin-right: 3%;

        .decree-widget {
            align-self: center;
            background: rgba(255, 255, 255, 0.65);
            box-sizing: border-box;
            border: 1px solid transparent;
            border-radius: 4px;
            box-shadow: 0px 1px 3px 1px rgba(123,125,125,0.25);
            cursor: pointer;
            font-size: 0;
            padding: 4px;
            position: relative;

            > * {
                align-self: center;
            }

            &.btn {
                padding: 4px;
            }

            &.disabled {
                cursor: not-allowed;

                &.btn-gray {

                    &:hover {
                        box-shadow: 0 3px $medium-gray;
                        top: 0;
                    }
                }

                .decree-marker {
                    cursor: not-allowed;
                }
            }

            &.spectator {
                background: white;
                cursor: default;

                .decree-marker {
                    cursor: default;
                }

                &.btn-gray {

                    &:hover {
                        box-shadow: 0 3px $medium-gray;
                        top: 0;
                    }
                }
            }

            &:hover {

                &:not(.disabled) {

                    &.white {

                        .decree-marker-wrapper {

                            &.white {

                                .decree-marker {
                                    opacity: 1;
                                }

                                .decree-shadow {
                                    display: block;
                                }
                            }
                        }
                    }

                    &.black {

                        .decree-marker-wrapper {

                            &.black {

                                .decree-marker,
                                .decree-shadow {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }

            &.last {
                margin-right: 0;
            }

            &.selectable {
                background: white;
                border: 1px solid $royal-coin-black;
            }

            .decree-name {
                padding: 0 10px;
                display: inline-block;
                vertical-align: middle;
                font-size: .9rem;
                font-family: 'IrishUncialfabeta', 'RobotoSlab', 'Avenir', Helvetica, Arial, sans-serif;
            }

            .decree-markers {
                box-sizing: border-box;
                display: flex;
                margin-top: 3px;

                .decree-marker-wrapper {
                    flex-grow: 1;
                    border-radius: 50%;

                    &.black {

                        .decree-marker {
                            opacity: .3;
                        }
                    }

                    &.claimed {

                        .decree-marker {
                            opacity: 1;
                        }

                        .decree-shadow {
                            display: block;
                        }
                    }
                }

                .decree-marker {
                    box-sizing: border-box;
                    height: auto;
                    width: 100%;
                    max-height: 40px;
                    max-width: 40px;
                    padding: 3px;
                    opacity: .5;
                }

                .decree-shadow {
                    display: none;
                    position: absolute;
                    width: auto;
                    height: auto;
                    left: 50%;
                    top: 50%;
                    height: 34px;
                    width: 34px;
                    border-radius: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .decree-widget-wrapper {

            .decree-widget {
                margin-right: 10px;
            }
        }
    }
</style>
